var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHmd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 111.5,
    width: 24,
    height: 177.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.9,
    y: 111.5,
    width: 24,
    height: 177.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 188,
    width: 92,
    height: 24
  }))), /*#__PURE__*/React.createElement("title", null, "Artboard 1"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 365.2,
    y1: 26.6,
    x2: 365.2,
    y2: 373.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 26.6,
    width: 6,
    height: 346.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.2,
    y1: 25.9,
    x2: 34.2,
    y2: 374.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 25.9,
    width: 6,
    height: 348.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32.8,
    y1: 70,
    x2: 201.7,
    y2: 152.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 17.1,
    transform: "matrix(0.4371 -0.8994 0.8994 0.4371 -33.8931 167.9261)",
    width: 2,
    height: 187.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 367.2,
    y1: 70.5,
    x2: 201.7,
    y2: 152.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.2,
    y: 110.3,
    transform: "matrix(0.8969 -0.4423 0.4423 0.8969 -19.8859 137.3005)",
    width: 184.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 33.8,
    y1: 324,
    x2: 199.3,
    y2: 256.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 289.4,
    transform: "matrix(0.9265 -0.3764 0.3764 0.9265 -100.716 65.2045)",
    width: 178.7,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 365.8,
    y1: 324,
    x2: 199.3,
    y2: 256.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.5,
    y: 200.6,
    transform: "matrix(0.3746 -0.9272 0.9272 0.3746 -92.5408 443.5563)",
    width: 2,
    height: 179.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 323.5,
    width: 331.5,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 69.5,
    width: 333,
    height: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmd);
export default __webpack_public_path__ + "static/media/hmd.5813267c220421e0bb7993db48173eb2.svg";
export { ForwardRef as ReactComponent };